import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { AuthShell } from "./LoginPage";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); setError("Jeton manquant"); return; }
    api.post("/auth/verify-email", { token })
       .then(() => setStatus("ok"))
       .catch((e) => { setStatus("error"); setError(formatApiError(e.response?.data?.detail)); });
  }, [params]);

  return (
    <AuthShell>
      <div className="mt-8 text-center">
        {status === "loading" && (<><Loader2 className="mx-auto h-10 w-10 text-primary animate-spin" /><h1 className="font-serif text-3xl mt-6">Vérification…</h1></>)}
        {status === "ok" && (<>
          <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-600" />
          <h1 className="font-serif text-3xl mt-6">Adresse confirmée</h1>
          <p className="mt-3 text-muted-foreground">Votre e-mail est maintenant vérifié.</p>
          <Button asChild className="btn-pill mt-8"><Link to="/app/assistant">Accéder à mon espace</Link></Button>
        </>)}
        {status === "error" && (<>
          <XCircle className="mx-auto h-14 w-14 text-destructive" />
          <h1 className="font-serif text-3xl mt-6">Lien invalide</h1>
          <p className="mt-3 text-muted-foreground">{error || "Impossible de vérifier votre adresse."}</p>
          <Button asChild variant="outline" className="btn-pill mt-8"><Link to="/login">Retour à la connexion</Link></Button>
        </>)}
      </div>
    </AuthShell>
  );
}
